import './style.css';

import {Map, View} from 'ol';

import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import LayerGroup from 'ol/layer/Group.js';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT.js';
import apply from 'ol-mapbox-style';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

import GeoJSON from 'ol/format/GeoJSON';
import GPX from 'ol/format/GPX';

import {useGeographic} from 'ol/proj';
useGeographic();

import RouteHelper from './andreasberge/RouteHelper';
import Wanderpunkte from './andreasberge/Wanderpunkte';
import Styles from './andreasberge/Styles';

const andreasbergeLayers = {};

const center = [10.519, 51.713];
const map = new Map({
    target: 'map',
    layers: [],
    view: new View({
        center: center,
        zoom: 13
    })
});

const basemapLayer = new VectorTileLayer({
    source: new VectorTileSource({
        url: "https://sgx.geodatenzentrum.de/gdz_basemapde_vektor/tiles/v2/bm_web_de_3857/{z}/{x}/{y}.pbf",
        format: new MVT()
    })
});
let basemapStyle;

// Fetch Basemap style document
fetch("basemap-style.json")
    .then(response => response.json())
    .then(style => {
        basemapStyle = style;
        map.addLayer(basemapLayer);
        apply(map, style);
        initView();
    });

const osmSource = new OSM({
    url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
});
const otmSource = new OSM({
    url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png'
});
const tileLayer = new TileLayer({
    source: osmSource
});

function osmMap() {
    tileLayer.setSource(osmSource);
    map.setLayers([tileLayer]);
}
function otmMap() {
    tileLayer.setSource(otmSource);
    map.setLayers([tileLayer]);
}
function baseMap() {
    map.setLayers([basemapLayer]);
    apply(map, basemapStyle);
}

function setSelectedInfos(infoSection) {
    const selectElement = document.getElementById('wanderabschnitt');
    const options = selectElement.options;
    for (let i = 0; i < options.length; i++) {
        const option = options[i];
        if (option.value == infoSection) {
            option.selected = true;
            return true;
        }
    }
    return false;
}

function setSelectedRoute(routeName) {
    const routeSelect = document.getElementById('routen');
    const options = routeSelect.options;
    for (let i = 0; i < options.length; i++) {
        const option = options[i];
        if (option.value == routeName) {
            option.selected = true;
            return true;
        }
    }
    return false;
}

function routeSelected(selectElement) {
    resetView();
    resetRoute();
    
    const abschnittSelect = document.getElementById('wanderabschnitt');
    abschnittSelect.selectedIndex = 0;

    const selectedOptions = selectElement.selectedOptions;
    for (let i = 0; i < selectedOptions.length; i++) {
        const routeName = selectedOptions[i].value;
        if (routeName == '') {
            continue;
        }
        addRouteVector(routeName);
        RouteHelper.addRouteLink(routeName);
        let fileName = routeName;
        if (routeName.indexOf('-nobar') > 0) {
            fileName = routeName.substring(0, routeName.indexOf('-nobar'));
        }
        if (RouteHelper.stadtnah.indexOf(routeName) == -1) {
            addGPXWanderpunkte('wanderpunkte/' + fileName + '.waypoints.gpx');
        } else {
            addGPXWanderpunkte('wanderpunkte-stadtrouten.gpx');
        }
    }
}

function abschnitteSelected(selectElement) {
    resetView();
    resetRoute();

    const routeSelect = document.getElementById('routen');
    routeSelect.selectedIndex = 0;
    
    const selectedOption = selectElement.selectedOptions[0].value;

    let abschnitte = [];
    let wanderpunkteGPX;
    let zoomLevel = 13;
    let pageSection;
    
    wanderpunkteGPX = 'wanderpunkte-ausgangspunkte.gpx';

    switch (selectedOption) {
    case 'Bushalte':
        zoomLevel = 10;
        wanderpunkteGPX = 'Bushaltestellen.gpx';
        break;
    case 'InsOdertal':
        abschnitte = [178,179,56,148,68,182,11,60,285,235,234];
        break;
    case 'InsSiebertal':
        abschnitte = [32,51,52,151,53,140,139,138,67,66,40,41,65,200,54,137,136,135,92,16,122,39,244];
        break;
    case 'Startpunkte':
        abschnitte = [221,4,26,3,17,25,12,251,156,252,38,201,208,230,229,111,14,120,259,226,228,58,223,234,172,222];
        zoomLevel = 14;

        pageSection = 'startpunkte';
        break;
    case 'Stadtnah':
        addRouteVector('Mariechenweg');
        addRouteVector('Engelsburger');
        addRouteVector('Jordanshöhe');
        addRouteVector('Sperrental-Kuppe');
        addRouteVector('Panorama-Sperrental');
        abschnitte = [3,26];
        wanderpunkteGPX = 'wanderpunkte-stadtrouten.gpx';

        pageSection = 'stadtnah';
        break;
    }
    if (typeof wanderpunkteGPX !== 'undefined') {
        addGPXWanderpunkte(wanderpunkteGPX);
    }
    if (abschnitte.length > 0) {
        displayWanderabschnitte(abschnitte, zoomLevel);
    }
    RouteHelper.addWanderIndexLink(pageSection);    
}

// adds wanderpunkte from a GPX file
function addGPXWanderpunkte(gpxFileName) {
    const vectorSource = new VectorSource({
        format: new GPX(),
        url: gpxFileName,
        projection: 'ESPG:3857'
    });
    addVectorLayer('wegepunkte', vectorSource);
}

// show wanderabschnitte from GEOJSON files
function displayWanderabschnitte(abschnitte, zoomLevel, selected) {
    if (typeof zoomLevel === 'undefined') {
        zoomLevel = 13;
    }
    for (let i = 0; i < abschnitte.length; i++) {
        const id = abschnitte[i];
        const vectorSource = new VectorSource({
            format: new GeoJSON(),
            url: './data/wanderabschnitt/' +  id + '.geojson',
            projection: 'ESPG:3857'
        });
        
        if (zoomLevel > 0) {
            vectorSource.once('change', function (e) {
                if (vectorSource.getState() === 'ready') {
                    const mapsize = map.getSize();
                    map.getView().setZoom(zoomLevel);
                    map.getView().centerOn(center,
                                           mapsize,
                                           [mapsize[0]/2, mapsize[1]/2]);
                }
            });
        }

        let aStyle, layerName, zIndex;
        if (typeof selected == 'undefined') {
            aStyle = Styles.getWanderabschnittStyle();
        } else {
            aStyle = Styles.getWanderabschnittStyle(selected);
        }
            
        const abschnittLayer = new VectorLayer({
            source: vectorSource,
            style: aStyle
        });
        map.addLayer(abschnittLayer);
        andreasbergeLayers['Abschnitt' + id] = abschnittLayer;
    }
}

function addRouteVector(name) {
    const vectorSource = new VectorSource({
        format: new GPX(),
        url: './routen/' + name +  '.route.gpx',
        projection: 'ESPG:3857'
    });
    addVectorLayer(name, vectorSource);
}

function addVectorLayer(name, vectorSource) {
    const vectorLayer = new VectorLayer({
        source: vectorSource,
        style: function (feature) {
            return Styles.getVectorStyle(name, feature);
        }
    });
    map.addLayer(vectorLayer);
    andreasbergeLayers[name] = vectorLayer;
    
    vectorSource.once('change', function (e) {
        if (vectorSource.getState() === 'ready') {
            const features = vectorLayer.getSource().getFeatures();
            if (features.length > 0) {
                if (name === 'wegepunkte') {
                    const waypoints = [];
                    features.forEach(feature => {
                        const type = feature.getGeometry().getType();
                        if (type == 'Point') {
                            waypoints.push(feature);
                        }
                    });
                    if (waypoints.length > 0) {
                        const pointLayer = Wanderpunkte.getPointLayer(waypoints);
                        andreasbergeLayers['punkte'] = pointLayer;
                        map.addLayer(pointLayer);
                    }

                    const vectorExtent = vectorSource.getExtent();
                    const view = map.getView();
                    view.fit(
                        vectorExtent,
                        {
                            size: map.getSize(),
                            padding: [30, 30, 30, 30]
                        }
                    );
                    if (view.getZoom() > 14) {
                        view.setZoom(14);
                    }
                }
            }
        }
    });
}


function resetView() {
    removeAndreasbergeLayers();
    RouteHelper.removeRouteInfo();
}

function removeAndreasbergeLayers() {
    const layers = Object.keys(andreasbergeLayers);
    layers.forEach(layer => {
        removeLayer(layer);
    });
}
function removeLayer(name) {
    map.removeLayer(andreasbergeLayers[name]);
    delete andreasbergeLayers[name];
}
function resetRoute() {
    const overlays = map.getOverlays();
    overlays.forEach(overlay => {
        map.removeOverlay(overlay);
    });
}


function initView() {
    const routeSelect = document.getElementById('routen');
    routeSelect.selectedIndex = 0;
    const abschnittSelect = document.getElementById('wanderabschnitt');
    abschnittSelect.selectedIndex = 0;

    const param = document.location.search;
    if (param.indexOf('route=') == 1) {
        const routename = param.substring(7);
        if (setSelectedRoute(routename)) {
            RouteHelper.addRouteLink(routename);
            if (RouteHelper.stadtnah.indexOf(routename) == -1) {
                addGPXWanderpunkte('wanderpunkte/' + routename + '.waypoints.gpx');
            } else {
                addGPXWanderpunkte('wanderpunkte-stadtrouten.gpx');
            }
            addRouteVector(routename);
        }
    }
    if (param.indexOf('infos=') == 1) {
        const infoname = param.substring(7);
        if (setSelectedInfos(infoname)) {
            abschnitteSelected(abschnittSelect);
        }
    }
}

// Routen
window.document.showRoute = routeSelected;
window.document.showAbschnitte = abschnitteSelected;
window.document.osmMap = osmMap;
window.document.otmMap = otmMap;
window.document.baseMap = baseMap;

window.addEventListener('load', (event) => {
});
